module.exports = __webpack_public_path__ + "img/JV.ad6bece1.png";